import {Progress as MantineProgress} from '@mantine/core';

/**
 * Linear progress bar — design-layer pass-through over Mantine `Progress`.
 * @registry Pass-through Mantine Progress; import this instead of @mantine/core outside src/design.
 */
export const Progress = MantineProgress;
